import React, { useState } from 'react';
import DateRangeSelector from './dateRangeSelector';
import ItemList from './itemList';
import Loader from '../loader';
import RetryReport from '../retryReport';
import { Box, Tab, Tabs, Tooltip } from '@mui/material';

const LargeCard = ({
  variant = "mileage",
  dateRange, setDateRange,
  showComparison, setShowChartComparison,
  handleCheckboxChange, handleTabChange,
  activeTab, renderContent, resetZoom,
  displayedData,
  config = {}, // configuración específica para cada variante
  progress,
  isReady,
  error,
  fetchReport,
  sectionNum
}) => {

  // Mapa de configuración por variantes
  const variantConfig = {
    speedViolations: {
      title: 'Excesos de velocidad por flota',
      additionalControls: () => (
        <>
          <input type="number" value={config.speedLimit} onChange={config.handleChangeSpeedLimit} />
          <Tooltip title={config.duplicateChartCard ? 'Ocultar duplicado' : 'Duplicar tarjeta'} arrow slotProps={{
            tooltip: {
              sx: {
                fontSize: '0.8rem',
                backgroundColor: '#333',
                color: '#fff',
                padding: '8px 15px',
                borderRadius: '8px',
              }
            }
          }}>
            <button onClick={() => config.setDuplicateChartCard(!config.duplicateChartCard)}>
              {config.duplicateChartCard ? 'Ocultar duplicado' : 'Duplicar tarjeta'}
            </button>
          </Tooltip>
        </>
      ),
      chartContent: renderContent,
    },
    topMaxSpeed: {
      title: `${config.showAll ? 'Todos los' : 'Top 5'} vehículos con mayor velocidad`,
      additionalControls: () => (
        <button onClick={config.handleShowAllToggle}>{config.showAll ? 'Ver menos' : 'Ver todos'}</button>
      ),
      chartContent: () => displayedData.map((item, index) => (
        <ItemList key={index} index={index + 1} name={item.car} data={item.data} />
      )),
    },
    fuelLoss: {
      title: 'Estimado de combustible perdido en ralentí',
      additionalControls: () => (
        <input type="number" value={config.fuelPerHour} onChange={config.handleChangeFuelPerHour} />
      ),
      chartContent: () => displayedData.map((item, index) => (
        <ItemList
          key={index}
          index={index + 1}
          type={'ralentiFuel'}
          name={item.car} // Nombre del vehículo
          data={{
            currentIdle: item.currentIdle,
            currentFuelLost: config.calculateFuelLoss(item.currentIdle), // Combustible perdido en el periodo actual
            previousIdle: item.previousIdle,
            previousFuelLost: config.calculateFuelLoss(item.previousIdle)// Combustible perdido en el periodo anterior
          }}
        />
      )),
    },
    mileage: {
      title: 'Kilometraje recorrido por flota',
      chartContent: renderContent,
    },
    ralenti: {
      title: 'Total de actividad del vehículo',
      chartContent: renderContent,
    },
    fuel: {
      title: 'Combustible consumido',
      chartContent: renderContent,
    },
  };

  const { title, additionalControls, chartContent } = variantConfig[variant] || variantConfig.mileage;

  return (
    <div className="dashboard_card card_chart card_large">
      {error ?
        <RetryReport fetchReport={fetchReport} sectionNum={sectionNum} />
        :
        progress < 100 || isReady ? (
          <Loader progress={progress} />
        ) : (
          <>
            <div className="dashboard_card_header_container">
              <span className="dashboard_card_title">{title}</span>
              <div className="config_chart_container">
                <DateRangeSelector dateRange={dateRange} setDateRange={setDateRange} />
                <Tooltip title='Comparar con el periodo previo' arrow slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '0.8rem',
                      backgroundColor: '#333',
                      color: '#fff',
                      padding: '8px 15px',
                      borderRadius: '8px',
                    }
                  }
                }}>
                  <label className="switch">
                    <input type="checkbox" checked={showComparison} onChange={() => setShowChartComparison(!showComparison)} />
                    <span className="slider"></span>
                  </label>
                </Tooltip>
                {additionalControls && additionalControls()}
              </div>
            </div>
            <div className="dashboard_card_content_container">
              {variant === 'fuelLoss' ?
                <div className='top_items_container' style={{ '--item-index-width': config.indexWidth }}>
                  <div className='top_items_header_container many_items'>
                    <span>Periodo</span>
                    <span>Actual</span>
                    <span>Anterior</span>
                  </div>
                  {
                    displayedData.length === 0 ?
                      <span className='text_no_vehicles'>Ningún vehículo seleccionado2</span>
                      :
                      chartContent()
                  }
                </div>
                :
                <>
                  {/* <div className="tabs">
                    <button onClick={() => handleTabChange('bar')} className={activeTab === 'bar' ? 'active' : ''}>Gráfica de Barras</button>
                    {variant === "mileage" || variant === "fuel" ? (
                      <>
                        <button onClick={() => handleTabChange('line')} className={activeTab === 'line' ? 'active' : ''}>Gráfica de Líneas</button>
                        {variant === "mileage" && (
                          <button onClick={() => handleTabChange('table')} className={activeTab === 'table' ? 'active' : ''}>Tabla</button>)
                        }
                      </>
                    ) : (
                      <button onClick={() => handleTabChange('pie')} className={activeTab === 'pie' ? 'active' : ''}>Gráfica de Pastel</button>
                    )}
                  </div> */}
                  <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '0.5rem' }}>
                    <Tabs
                      value={activeTab}
                      onChange={(e, newValue) => handleTabChange(newValue)}
                      textColor="primary"
                      indicatorColor="primary"
                      sx={{
                        minHeight: 0,
                        '.MuiTab-root': { minHeight: 0, padding: '10px 12px', fontSize: '0.75rem', textTransform: 'none' },
                      }}
                    >
                      <Tab label="Gráfica de Barras" value="bar" />
                      {(variant === "mileage" || variant === "fuel") && <Tab label="Gráfica de Líneas" value="line" />}
                      {(variant === "mileage") && <Tab label="Tabla" value="table" />}
                      {!(variant === "mileage" || variant === "fuel") && <Tab label="Gráfica de Pastel" value="pie" />}
                    </Tabs>
                  </Box>

                  <div className="tabs_container">{chartContent()}</div>
                  {
                    variant === "mileage" && (
                      <div className='chart_bottom_container'>
                        <div className='chart_period_container'>
                          <div>
                            <span>Periodo actual: </span>
                            <span id="current-period-mileage">0 km</span>
                            <br />
                            <span className='period_date' id='current-period-date-mileage'></span>
                          </div>
                          <div>
                            <span>Periodo anterior: </span>
                            <span id="previous-period-mileage">0 km</span>
                            <br />
                            <span className='period_date' id='previous-period-date-mileage'></span>
                          </div>
                        </div>
                        {(activeTab === 'bar' || activeTab === 'line') && dateRange > 0 ? <button className='restart_zoom_btn' onClick={resetZoom}>Restablecer Zoom</button> : ''}
                      </div>
                    )
                  }
                  {
                    variant === "fuel" && (
                      <div className='chart_bottom_container'>
                        <div className='chart_period_container'>
                          <div>
                            <span>Periodo actual: </span>
                            <span id="current-period-fuel">0 L</span>
                            <br />
                            <span className='period_date' id='current-period-date-fuel'></span>
                          </div>
                          <div>
                            <span>Periodo anterior: </span>
                            <span id="previous-period-fuel">0 L</span>
                            <br />
                            <span className='period_date' id='previous-period-date-fuel'></span>
                          </div>
                        </div>
                        {(activeTab === 'bar' || activeTab === 'line') && dateRange > 0 ? <button className='restart_zoom_btn' onClick={resetZoom}>Restablecer Zoom</button> : ''}
                      </div>
                    )
                  }
                  {
                    variant === 'ralenti' && activeTab === 'bar' && (
                      <div className='chart_bottom_container'>
                        <div className='chart_period_container'>
                          <div>
                            <span>En ralentí: </span>
                            <br />
                            <span>En movimiento: </span>
                          </div>
                          <div>
                            <span>Periodo actual: </span>
                            <br />
                            <span id="current-period-ralenti">00h 00m 00s</span>
                            <br />
                            <span id="current-period-in_movement">00h 00m 00s</span>
                            <br />
                            <span className='period_date' id='current-period-date-ralenti'></span>
                          </div>
                          <div></div>
                          <div>
                            <span>Periodo anterior: </span>
                            <br />
                            <span id="previous-period-ralenti">00h 00m 00s</span>
                            <br />
                            <span id="previous-period-in_movement">00h 00m 00s</span>
                            <br />
                            <span className='period_date' id='previous-period-date-ralenti'></span>
                          </div>
                        </div>
                        {(activeTab === 'bar' || activeTab === 'line') && dateRange > 0 ? <button className='restart_zoom_btn' onClick={resetZoom}>Restablecer Zoom</button> : ''}
                      </div>
                    )
                  }
                </>
              }
            </div>
          </>
        )}
    </div>
  );
};

// Exporta el componente para que pueda ser utilizado en otros archivos
export default LargeCard;
